<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Target",
};
</script>

<style lang="scss" scoped></style>
